import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-619796ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "password-model",
  ref: "passwordModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip top" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-zhongzhimima" }),
    /*#__PURE__*/_createTextVNode(" 是否重置密码？ ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "tip bottom" }, "重置后的密码为htht@123")
], -1))

import {
  reactive, withDefaults, ref, watch,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Modal, Button, message, Input,
} from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

interface Props {
  passwordVisible?: boolean,
  userInfo?: any,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    passwordVisible: { type: Boolean, default: false },
    userInfo: { default: Object }
  },
  emits: ['save', 'cancal',],
  setup(__props: any, { emit: emits }) {

const props = __props as { passwordVisible: boolean, userInfo: any }

const store = useStore();

const { Password, } = Input;





const handleConfirm = () => {
  const params = {
    id: props.userInfo.id,
  };

  store.dispatch('userCenter/resetPassword', params).then(() => {
    emits('save');
  });
};

const handleCancle = (): void => {
  emits('cancal');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.passwordModel,
      title: "密码重置",
      width: '4.2rem',
      footer: false,
      visible: props.passwordVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: handleCancle
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleConfirm
          }, "确定")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "width", "visible"])
  ], 512))
}
}

})